import { useState, Fragment, useMemo } from 'react'
import {
  EuiPageBody,
  EuiFlexGroup,
  EuiIcon,
  EuiTitle,
  EuiPageContent,
  EuiPageContentHeader,
  EuiPageContentHeaderSection,
  EuiPageContentBody,
  EuiTabs,
  EuiTab,
  EuiSpacer,
  EuiErrorBoundary,
} from '@elastic/eui'
import PageHeader from '../components/Header'
import AdminUsersLogs from './AdminUsersLogs'
import AdminKpisLogs from './AdminKpisLogs'
import AdminSettingsForm from './AdminSettingsForm'
import AdminKpisList from './AdminKpisList'

const tabs = [
  {
    id: 'reports--tab--id',
    name: 'Rapports',
    content: (
      <Fragment>
        <EuiSpacer size="l" />
        <AdminKpisList />
      </Fragment>
    ),
  },
  {
    id: 'users_logs--tab--id',
    name: 'Connexions',
    content: (
      <Fragment>
        <EuiSpacer size="l" />
        <AdminUsersLogs />
      </Fragment>
    ),
  },
  {
    id: 'kpis_logs--tab--id',
    name: 'Agrégations',
    content: (
      <Fragment>
        <EuiSpacer size="l" />
        <AdminKpisLogs />
      </Fragment>
    ),
  },
  {
    id: 'settings--tab--id',
    name: 'Configuration',
    content: (
      <Fragment>
        <EuiSpacer size="l" />
        <AdminSettingsForm />
      </Fragment>
    ),
  },
]

function Admin(props) {
  const [selectedTabId, setSelectedTabId] = useState('reports--tab--id')
  const { selectedItemName, selectedItemIcon } = props

  const selectedTabContent = useMemo(() => {
    return tabs.find((obj) => obj.id === selectedTabId)?.content
  }, [selectedTabId])

  const onSelectedTabChanged = (id) => {
    setSelectedTabId(id)
  }

  const renderTabs = () => {
    return tabs.map((tab, index) => (
      <EuiTab
        key={index}
        href={tab.href}
        onClick={() => onSelectedTabChanged(tab.id)}
        isSelected={tab.id === selectedTabId}
        disabled={tab.disabled}
        prepend={tab.prepend}
        append={tab.append}
      >
        {tab.name}
      </EuiTab>
    ))
  }

  return (
    <>
      <EuiPageBody component="div">
        <PageHeader />
        <EuiPageContent id="contentPage">
          <EuiPageContentHeader id="adminHeader">
            <EuiPageContentHeaderSection>
              <EuiFlexGroup>
                <EuiIcon type={selectedItemIcon} />
                <EuiTitle size="l">
                  <h2>{selectedItemName}</h2>
                </EuiTitle>
              </EuiFlexGroup>
              <EuiSpacer></EuiSpacer>
              <EuiTabs id="adminTabs">{renderTabs()}</EuiTabs>
            </EuiPageContentHeaderSection>
          </EuiPageContentHeader>
          <EuiPageContentBody id="adminContent">
            <EuiErrorBoundary>{selectedTabContent}</EuiErrorBoundary>
          </EuiPageContentBody>
        </EuiPageContent>
      </EuiPageBody>
    </>
  )
}

export default Admin
